export const sanitizePhone = (phone: string) => {
  if (!phone || typeof phone !== "string") return;

  const draft = phone.replace("-", "");

  if (draft.length < 8 || draft.length > 8) return null;

  return draft;
};

export const formatPhone = (phone?: string, countryCode?: number) => {
  if (!phone) return "";
  const draft = sanitizePhone(phone);
  if (!draft) return "";

  const newDraft = Array.from(draft);

  newDraft.splice(4, 0, "-");

  if (countryCode) {
    return `+(${countryCode}) ${newDraft.join("")}`;
  }

  return newDraft.join("");
};
